import React, { ReactNode } from 'react'
import styles from './index.module.scss'
import Consumo from './assets/consumo.svg'
import Lluvia from './assets/lluvia.svg'
import Ruido from './assets/ruido.svg'
import { t } from '../../../../i18n'
import Size from '../../../../utils/media-queries-setup'

type Props = {
  children: ReactNode
  colour?: string
  icon: 'consumo' | 'lluvia' | 'decibelios'
  isFullInfo?: boolean
}

const EcoLabelBox = ({
  children,
  colour,
  isFullInfo = true,
  ...props
}: Props) => {
  const { icon } = props
  const isMobile = Size.useMedia({
    mobile: true,
    tablet: true,
    desktop: false,
  })
  return (
    <div className={styles.ecoLabelBox_wrapper}>
      {icon === 'consumo' && (
        <>
          <Consumo className={styles.icon} />
          {!isMobile && isFullInfo && (
            <span className={styles.iconText}>
              {t('catalogo.producto.ficha.section_ecolabels.consumo')}
            </span>
          )}
        </>
      )}
      {icon === 'lluvia' && (
        <>
          <Lluvia className={styles.icon} />
          {!isMobile && isFullInfo && (
            <span className={styles.iconText}>
              {t('catalogo.producto.ficha.section_ecolabels.frenado')}
            </span>
          )}
        </>
      )}
      {icon === 'decibelios' && (
        <>
          <Ruido className={styles.icon} />{' '}
          {!isMobile && isFullInfo && (
            <span className={styles.iconText}>
              {t('catalogo.producto.ficha.section_ecolabels.decibelios')}
            </span>
          )}
        </>
      )}
      <div
        className={
          ['consumo', 'lluvia'].includes(icon)
            ? `${styles.signpost} ${styles[`signpost_${colour}`]}`
            : styles.noSignpost
        }>
        <span>{children}</span>
      </div>
    </div>
  )
}

export default EcoLabelBox
